import { render, staticRenderFns } from "./notag-returen-modal.vue?vue&type=template&id=d42085a8&"
import script from "./notag-returen-modal.vue?vue&type=script&lang=js&"
export * from "./notag-returen-modal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports